import React from "react";

import { CustomerAccountInfo, CustomerAccountInfoType } from "./Customer.types";
import { v4 as uuidv4 } from "uuid";

export const CustomerContext =
  React.createContext<CustomerAccountInfoType | null>(null);
  
const registeredAddressId = uuidv4();
const billingAddressId = uuidv4();
const shippingAddressId = uuidv4();
const fapiaoAddressId = uuidv4();
export const REGISTERED_ADDRESS = "Registered Address";
export const BILLING_ADDRESS = "Billing";
export const Shipping_ADDRESS = "Shipping";
export const FAPIAO_ADDRESS = "Fapiao";

export const intialCustomerInfo = {
  accountId: "",
  id: "",
  taxId: "",
  sapAccountId: "",
  legalAccountId: "",
  affilation: "",
  authorizedBuyerFirstName: "",
  authorizedBuyerLastName: "",
  authorizedBuyerTitle: "",
  authorizedBuyerPhone: "",
  authorizedEmailId: "",
  name: "",
  paymentTerms: "",
  country: "",
  customerRegion:"",
  registerAddress: {
    addressId: registeredAddressId,
    affilation: REGISTERED_ADDRESS,
    name: "",
    street: "",
    postalCode: "",
    city: "",
    province: "",
    country: "",
    registeredtaxId:"",
    customerCertifiedEmail:"",
    customerConsigneeCode:"",
    purchasingCompanyTaxId: "",
    shipmentCompanyTaxId: "",
    sapAccountId: "",
    contacts: {
      contactId: "",
      contactFirstName: "",
      contactLastName: "",
      contactPhone: "",
      contactEmail: "",
      isContactPrimary: "No",
    },
    state: "",
    isAddressPrimary: ""
  },
  billingAddress: {
    addressId: billingAddressId,
    affilation: BILLING_ADDRESS,
    name: "",
    street: "",
    postalCode: "",
    city: "",
    province: "",
    country: "",
    registeredtaxId:"",
    customerCertifiedEmail:"",
    customerConsigneeCode:"",
    purchasingCompanyTaxId: "",
    shipmentCompanyTaxId: "",
    sapAccountId: "",
    contacts: {
      contactId: "",
      contactFirstName: "",
      contactLastName: "",
      contactPhone: "",
      contactEmail: "",
      isContactPrimary: "Yes",
    },
    state: "",
    isAddressPrimary: "Yes"
  },
  shippingAddress: {
    addressId: shippingAddressId,
    affilation: Shipping_ADDRESS,
    name: "",
    street: "",
    postalCode: "",
    city: "",
    province: "",
    country: "",   
    registeredtaxId:"",
    customerCertifiedEmail:"",
    customerConsigneeCode:"",
    purchasingCompanyTaxId: "",
    shipmentCompanyTaxId: "",
    sapAccountId: "",
    contacts: {
      contactId: "",
      contactFirstName: "",
      contactLastName: "",
      contactPhone: "",
      contactEmail: "",
      isContactPrimary: "Yes",
    },
    state: "",
    isAddressPrimary: "Yes"
  },
  fapiaoAddress: {
    addressId: fapiaoAddressId,
    affilation: FAPIAO_ADDRESS,
    name: "",
    street: "",
    postalCode: "",
    city: "",
    province: "",
    country: "", 
    registeredtaxId: " ",
    customerCertifiedEmail:"",
    customerConsigneeCode:"",
    purchasingCompanyTaxId: "",
    shipmentCompanyTaxId: "",
    sapAccountId: "",
    contacts: {
      contactId: "",
      contactFirstName: "",
      contactLastName: "",
      contactPhone: "",
      contactEmail: "",
      isContactPrimary: "Yes",
    },
    state: "",
    isAddressPrimary: "Yes"
  },
  discount: {
    afilliationSelected: "",
    contract: [],
    taxExempt: {
      isTaxExemptChecked: false,
      expirationDate: "",
      taxExemptReason: "",
    },
    customerGroup: {
      governmentDiscountSelected: false,
      employeePricingSelected: false,
      couponCode: [],
    },
    restrictedSkus: "",
  },
};

const CustomerProvider: React.FC<React.ReactNode> = ({ children }) => {
  const [customerAccountInfo, setCustomerAccountInfoData] =
    React.useState<CustomerAccountInfo>(intialCustomerInfo);

  const setCustomerAccountInfo = (
    customerAccountInfos: CustomerAccountInfo
  ) => {
    setCustomerAccountInfoData({
      ...customerAccountInfo,
      name: customerAccountInfos.name,
      accountId: customerAccountInfos.accountId,
      sapAccountId: customerAccountInfos.sapAccountId,
      taxId: customerAccountInfos.taxId,
      legalAccountId: customerAccountInfos.legalAccountId,
      affilation: customerAccountInfos.affilation,
      authorizedBuyerFirstName: customerAccountInfos.authorizedBuyerFirstName,
      authorizedBuyerLastName: customerAccountInfos.authorizedBuyerLastName,
      authorizedBuyerTitle: customerAccountInfos.authorizedBuyerTitle,
      authorizedBuyerPhone: customerAccountInfos.authorizedBuyerPhone,
      authorizedEmailId: customerAccountInfos.authorizedEmailId,     
      paymentTerms: customerAccountInfos.paymentTerms,
      registerAddress: customerAccountInfos.registerAddress,
      billingAddress: customerAccountInfos.billingAddress,
      shippingAddress: customerAccountInfos.shippingAddress,
      fapiaoAddress: customerAccountInfos.fapiaoAddress,
      country: customerAccountInfos.country,
      id: customerAccountInfos.id,
      discount: customerAccountInfos.discount,
    } as CustomerAccountInfo);
  };

  return (
    <CustomerContext.Provider
      value={{ customerAccountInfo, setCustomerAccountInfo }}
    >
      {children}
    </CustomerContext.Provider>
  );
};

export default CustomerProvider;
